export default __webpack_public_path__ + "static/media/step3.c4e3007f.png";